module.exports = __webpack_public_path__ + "media/components/src/assets/images/order-gift-packaging/navigate_next-c7812bb28e825fd1af1122738f2e2f7b.svg";